import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { PWAInstallButton } from './PWAInstallButton';
import { AUTH_LIGHT_SCREEN_BG, useBodyBackgroundOnMount } from '../hooks/useBodyBackgroundOnMount';

export default function LandingPage() {
  useBodyBackgroundOnMount(AUTH_LIGHT_SCREEN_BG);

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 to-blue-50 flex items-center justify-center p-4">
      <div className="text-center">
        <img
          src="/handra_logo.svg"
          alt="Handra"
          className="mx-auto mb-4 w-32 h-32 sm:w-40 sm:h-40"
        />
        <h1 className="text-4xl sm:text-5xl font-bold text-teal-600 mb-4">
          Handra
        </h1>
        <p className="text-2xl text-gray-700 mb-6">
          歯科医院申し送りシステム
        </p>
        <Button
          asChild
          variant="cta"
          size="lg"
          className="px-8 py-6 text-lg font-semibold rounded-lg shadow-md hover:shadow-lg transition-shadow"
        >
          <Link to="/login">ログイン</Link>
        </Button>
        <div className="mt-4 flex justify-center">
          <PWAInstallButton />
        </div>
      </div>
    </div>
  );
}

